// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file finance/v1/bill_events.proto (package finance.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Bill, BillStatus } from "./domain_pb.js";
import { file_finance_v1_domain } from "./domain_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file finance/v1/bill_events.proto.
 */
export const file_finance_v1_bill_events: GenFile = /*@__PURE__*/
  fileDesc("ChxmaW5hbmNlL3YxL2JpbGxfZXZlbnRzLnByb3RvEgpmaW5hbmNlLnYxIoECCglCaWxsRXZlbnQSLwoHY3JlYXRlZBgBIAEoCzIcLmZpbmFuY2UudjEuQmlsbENyZWF0ZWRFdmVudEgAEi8KB3VwZGF0ZWQYAiABKAsyHC5maW5hbmNlLnYxLkJpbGxVcGRhdGVkRXZlbnRIABIvCgdkZWxldGVkGAMgASgLMhwuZmluYW5jZS52MS5CaWxsRGVsZXRlZEV2ZW50SAASLQoGdm9pZGVkGAQgASgLMhsuZmluYW5jZS52MS5CaWxsVm9pZGVkRXZlbnRIABIpCgRwYWlkGAUgASgLMhkuZmluYW5jZS52MS5CaWxsUGFpZEV2ZW50SABCBwoFZXZlbnQiMgoQQmlsbENyZWF0ZWRFdmVudBIeCgRiaWxsGAEgASgLMhAuZmluYW5jZS52MS5CaWxsImMKEEJpbGxVcGRhdGVkRXZlbnQSJwoNcHJldmlvdXNfYmlsbBgBIAEoCzIQLmZpbmFuY2UudjEuQmlsbBImCgx1cGRhdGVkX2JpbGwYAiABKAsyEC5maW5hbmNlLnYxLkJpbGwiMgoQQmlsbERlbGV0ZWRFdmVudBIeCgRiaWxsGAEgASgLMhAuZmluYW5jZS52MS5CaWxsImIKD0JpbGxWb2lkZWRFdmVudBIeCgRiaWxsGAEgASgLMhAuZmluYW5jZS52MS5CaWxsEi8KD3ByZXZpb3VzX3N0YXR1cxgCIAEoDjIWLmZpbmFuY2UudjEuQmlsbFN0YXR1cyJgCg1CaWxsUGFpZEV2ZW50Eh4KBGJpbGwYASABKAsyEC5maW5hbmNlLnYxLkJpbGwSLwoPcHJldmlvdXNfc3RhdHVzGAIgASgOMhYuZmluYW5jZS52MS5CaWxsU3RhdHVzQjNaMXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWZpbmFuY2UvYXBpL3YxO2ZpbmFuY2VfdjFiCGVkaXRpb25zcOgH", [file_finance_v1_domain]);

/**
 * @generated from message finance.v1.BillEvent
 */
export type BillEvent = Message<"finance.v1.BillEvent"> & {
  /**
   * @generated from oneof finance.v1.BillEvent.event
   */
  event: {
    /**
     * @generated from field: finance.v1.BillCreatedEvent created = 1;
     */
    value: BillCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: finance.v1.BillUpdatedEvent updated = 2;
     */
    value: BillUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: finance.v1.BillDeletedEvent deleted = 3;
     */
    value: BillDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: finance.v1.BillVoidedEvent voided = 4;
     */
    value: BillVoidedEvent;
    case: "voided";
  } | {
    /**
     * @generated from field: finance.v1.BillPaidEvent paid = 5;
     */
    value: BillPaidEvent;
    case: "paid";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message finance.v1.BillEvent.
 * Use `create(BillEventSchema)` to create a new message.
 */
export const BillEventSchema: GenMessage<BillEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_bill_events, 0);

/**
 * @generated from message finance.v1.BillCreatedEvent
 */
export type BillCreatedEvent = Message<"finance.v1.BillCreatedEvent"> & {
  /**
   * @generated from field: finance.v1.Bill bill = 1;
   */
  bill?: Bill;
};

/**
 * Describes the message finance.v1.BillCreatedEvent.
 * Use `create(BillCreatedEventSchema)` to create a new message.
 */
export const BillCreatedEventSchema: GenMessage<BillCreatedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_bill_events, 1);

/**
 * @generated from message finance.v1.BillUpdatedEvent
 */
export type BillUpdatedEvent = Message<"finance.v1.BillUpdatedEvent"> & {
  /**
   * @generated from field: finance.v1.Bill previous_bill = 1;
   */
  previousBill?: Bill;

  /**
   * @generated from field: finance.v1.Bill updated_bill = 2;
   */
  updatedBill?: Bill;
};

/**
 * Describes the message finance.v1.BillUpdatedEvent.
 * Use `create(BillUpdatedEventSchema)` to create a new message.
 */
export const BillUpdatedEventSchema: GenMessage<BillUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_bill_events, 2);

/**
 * @generated from message finance.v1.BillDeletedEvent
 */
export type BillDeletedEvent = Message<"finance.v1.BillDeletedEvent"> & {
  /**
   * @generated from field: finance.v1.Bill bill = 1;
   */
  bill?: Bill;
};

/**
 * Describes the message finance.v1.BillDeletedEvent.
 * Use `create(BillDeletedEventSchema)` to create a new message.
 */
export const BillDeletedEventSchema: GenMessage<BillDeletedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_bill_events, 3);

/**
 * @generated from message finance.v1.BillVoidedEvent
 */
export type BillVoidedEvent = Message<"finance.v1.BillVoidedEvent"> & {
  /**
   * @generated from field: finance.v1.Bill bill = 1;
   */
  bill?: Bill;

  /**
   * @generated from field: finance.v1.BillStatus previous_status = 2;
   */
  previousStatus: BillStatus;
};

/**
 * Describes the message finance.v1.BillVoidedEvent.
 * Use `create(BillVoidedEventSchema)` to create a new message.
 */
export const BillVoidedEventSchema: GenMessage<BillVoidedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_bill_events, 4);

/**
 * @generated from message finance.v1.BillPaidEvent
 */
export type BillPaidEvent = Message<"finance.v1.BillPaidEvent"> & {
  /**
   * @generated from field: finance.v1.Bill bill = 1;
   */
  bill?: Bill;

  /**
   * @generated from field: finance.v1.BillStatus previous_status = 2;
   */
  previousStatus: BillStatus;
};

/**
 * Describes the message finance.v1.BillPaidEvent.
 * Use `create(BillPaidEventSchema)` to create a new message.
 */
export const BillPaidEventSchema: GenMessage<BillPaidEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_bill_events, 5);

